import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import URLS from 'constant/URLS'

let logo
if (__CLIENT)
    logo = require('client/assets/images/logo.gif')
class Anonymous extends Component {

    componentDidUpdate() {
        if (this.props.session.loggingIn) this.context.router.push(URLS.home)
    }

    render() {
        return (
            <div>
                <div className='text-center logo-alt-box'>
                    <a href={ URLS.home } className='logo'><span>Beeo<span>App</span></span></a>
                    <h5 className='text-muted m-t-0'>Back-office</h5>
                </div>
                <div className='wrapper-page'>
        	        <div className='m-t-30 card-box'>
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}

Anonymous.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

export default connect(
      mapStateToProps
)(Anonymous)


// WEBPACK FOOTER //
// ./src/client/features/app/containers/Anonymous.jsx